module.exports = __webpack_public_path__ + "assets/img/Slice1.cb14e765.png";